import React from 'react';
import { Row, Col } from 'react-flexbox-grid';
import styled from 'styled-components';

import { PageGrid } from '../shared/CommonStyledComponents';
import NextPageLink from '../shared/NextPageLink';

import forDevelopersBg from '../assets/images/for_developers_bg.svg';
import leafyKatha from '../assets/images/forDevelopers/leafy-katha.png';
import kundaliya from '../assets/images/forDevelopers/kundaliya.png';
import contactSideLink from '../assets/images/sideLinks/contact_side_link.svg';


const ForDevelopersRow = styled(Row)`
  width: 85%;

  @media (max-width: 64em) {
    width: auto;
  }
`;

const PageTitle = styled.h2`
  font-size: 5.5vw;
  margin-top: 0vw;
  line-height: 4.8vw;
  margin-bottom: 1vw;
  background: url(${forDevelopersBg}) no-repeat;
  background-size: auto 100%;
  padding-top: 10px;
  padding-bottom: 10px;

  @media (max-width: 64em) {
    font-size: 8.5vw;
    line-height: 7.8vw;
  }
`;

const PageDescription = styled.p`
  column-count: 2;
  font-size: 1vw;

  @media (max-width: 64em) {
    font-size: 3vw;
    column-count: 1;
  }
`;

const ForDevelopersItem = styled(Col)`
  border-left: 1px solid;

  &:hover{
    .for-developers-image{
      filter: grayscale(1) blur(2px);
      -webkit-filter: grayscale(1) blur(2px);
    }
  }

  @media (max-width: 64em) {
    border-left: none;
    margin-top: 10px;
  }
`;

const ForDevelopersItemLink = styled.a`
  text-decoration: none;
  color: #262636;
`;

const ForDevelopersItemImage = styled.img`
  width: calc(100% - 10px);
  border: 1px solid;
  padding: 4px;
  filter: grayscale(0) blur(0);
  -webkit-filter: grayscale(0) blur(0);
  -webkit-transition: all 0.4s;
  transition: all 0.4s;
`;

const ForDevelopersItemTitle = styled.h3`
  margin-top: 6px;
  margin-bottom: -8px;
  font-size: 1.5vw;

  @media (max-width: 64em) {
    font-size: 5.5vw;
    margin-bottom: 2px;
  }
`;

const ForDevelopersItemDetails = styled.p`
  font-size: 1vw;

  @media (max-width: 64em) {
    font-size: 3vw;
  }
`;


const ForDevelopers = () => (
  <PageGrid id="fordevelopers">
    <ForDevelopersRow>
      <Col xs={12} md={6}>
        <PageTitle>
          FROM<br />DEVELOPERS<br />FOR<br />DEVELOPERS
        </PageTitle>

        <PageDescription>
          At LeafyCode we believe we should rise with the community. We don&apos;t want to be a lone
          star. We want to help our fellow developers and take them to the next level with us.
          <br />
          <br />
          Our team loves to share what they learn. We are good at finding and learning new stuff.
          We can&apos;t survive in this industry if we don&apos;t keep ourselves updated. So, why
          not share it with the others?
          <br />
          <br />
          There are many great minds out there stuck without proper guidance. If helped, they
          can do many great things to the world. We want to help them and see what they will
          do to our industry.
          <br />
          <br />
          Our team have introduced several unique programs to help our fellow developers. Some are
          already launched and some are still on the drawing boards. But we believe we can do a
          big change in the industry with the help of the community!
        </PageDescription>
      </Col>
      <ForDevelopersItem xs={12} md={2}>
        <ForDevelopersItemLink
          href="https://www.youtube.com/c/SLDevTalks"
          target="_blank"
          rel="noopener noreferrer"
        >
          <ForDevelopersItemImage
            src={leafyKatha}
            alt="Leafy Katha"
            className="for-developers-image"
          />
          <ForDevelopersItemTitle>LEAFY KATHA</ForDevelopersItemTitle>
        </ForDevelopersItemLink>
        <ForDevelopersItemDetails>
          A podcast created by developers for developers.
          <br />
          <br />
          We believe a very powerful community can do almost anything. Sri Lanka has incredible
          people with great capabilities. But for several reasons, only a few of these people
          reach their full potential and do something for the country. Some leave their country.
          Many won&apos;t get what they need to grow themselves. We want to find them, build a
          strong community and challenge the world together! The journey will be tough.
          If you think you can take it, come join us!
        </ForDevelopersItemDetails>
      </ForDevelopersItem>
      <ForDevelopersItem xs={12} md={2}>
        <ForDevelopersItemLink
          href="http://akurucollective.com/kundaliya/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <ForDevelopersItemImage
            src={kundaliya}
            alt="Kundaliya"
            className="for-developers-image"
          />
          <ForDevelopersItemTitle>KUNDALIYA</ForDevelopersItemTitle>
        </ForDevelopersItemLink>
        <ForDevelopersItemDetails>
          Kundaliya is a web application we built for the Akuru Collective. It is an
          organisation dedicated to improving Sinhala typography. They have done a huge
          difference for our local type industry by improving Sinhala Unicode fonts and
          raising awareness by organising events like the Typo Day here in Sri Lanka.
          <br />
          <br />
          They requested our help on building a small application to help them hold a
          competition to raise awareness to the Sinhala full stop (Kundaliya). So, we
          accepted the challenge!
        </ForDevelopersItemDetails>
      </ForDevelopersItem>
      <ForDevelopersItem xs={12} md={2}>
        <ForDevelopersItemTitle>
          CONTRIBUTIONS TO OPEN SOURCE PROJECTS AND MORE...
        </ForDevelopersItemTitle>
        <ForDevelopersItemDetails>
          At LeafyCode we always encourage our team to contribute to open source projects and
          help the community. We don&apos;t want to just report bugs and wait till the community
          fix it. If we can fix it ourselves, we will do it and push it for the community.
          <br />
          <br />
          There are many people trying to help fellow developers through meetups.
          We help them whenever we can and encourage them to do more for the community.
          <br />
          <br />
          These are only a few programs we have for our fellow developers. There will be more...
        </ForDevelopersItemDetails>
      </ForDevelopersItem>
    </ForDevelopersRow>
    <NextPageLink
      color="ED3246"
      image={contactSideLink}
      text="CONTACT US"
    />
  </PageGrid>
);

export default ForDevelopers;



// WEBPACK FOOTER //
// ./src/components/ForDevelopers.js